import React, { useState, useEffect } from "react";
import Form from "./Form";
import authHeader from "../services/AuthHeader";
import axios from 'axios';
import AuthService from '../services/AuthService';
import { useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

const Vote = (props) => {
  const [user, ] = useState([]);
  const [showBallot,setShowBallot] = useState(false);
  const [votes, ] = useState(
    {
      "ElectionId": "",
      "UUID": "",
      "StarId" : "",
      "allBallots": []
    }
  );
  const [isNotLocked, setIsNotLocked] = useState(false);
  const [isNotStudent, setIsNotStudent] = useState(false);
  const electionTitle = props.ballotData && props.ballotData.electionName
    ? props.ballotData.electionName
    : 'Election Ballot';
  
  let history = useHistory();
  /* Check if student has voted */
  useEffect(() => {
        if (AuthService.alreadyVoted()) {
            setShowBallot(false);
            setTimeout(function(){ history.push("/validate"); }, 1000);
        } else {
            setShowBallot(true);
        } 

  }, []);

  /* Get student and election data */
  useEffect(() => {
    if (AuthService.isStudent()) {
     axios
      .get(
        process.env.REACT_APP_API_BASE + 'studentinfo/' + AuthService.getStarId(),{ headers: authHeader() }
      )
      .then((res) => {
        props.setStudentInfo(res.data);
        let tempVotes = votes;

        axios
          .get(
            process.env.REACT_APP_API_BASE + 'election/',{ headers: authHeader() }
          )
          .then((res2) => {
            if(res2.data.activeStatus) {
              props.setBallotData(res2.data);
              tempVotes.ElectionId = res2.data.electionId;
              tempVotes.UUID = uuidv4();
              tempVotes.allBallots = [];
              tempVotes.StarId = AuthService.getStarId();
              props.setVotes(tempVotes);
              setIsNotLocked(false);
            } else {
              setIsNotLocked(true);
            }
          });
      });
    } else {
      setIsNotStudent(true);
    }
  }, []);
  
  /* Show student info */
  const ShowStudent = ()=> {
    if(props.studentInfo.allColleges) {
        return (
          <>
              <div className='box-voter text-center'>
                  <h2 className='h3'>Your Information</h2>
                  <div>{props.studentInfo.first_Name} {props.studentInfo.last_Name}</div>
                  <div>{props.studentInfo.residential === 'O'? 'Off-Campus':'On-Campus'} Resident</div>
                  <div>{props.studentInfo.classLevel==='U'? 'Undergraduate':"Graduate"}</div>
                  <div>{props.studentInfo.allColleges.map(function(item, index) {
                      return (index < (props.studentInfo.allColleges.length -1)) ? item['collegeDescription']+', ' : item['collegeDescription'];
                    })}</div> 
              </div>
              <br />
          </>
        )
    } else {
        return (<div>Please contact the student office</div>)
    }
}


if (isNotStudent) {
  return <div className="App"><b>You do not have permission to access this page</b></div>;
}


if (isNotLocked) {
  return <div className="App"><b>Election is not active</b></div>;
}

if (!showBallot) {
  return <div className="App"><b>You have already voted</b></div>;
}

return  (Object.keys(props.ballotData).length ? (
    <>
      <h1>{electionTitle}</h1>
      <ShowStudent />
      <Form ballotData={props.ballotData} showElectionHeading={false} user={user} studentInfo={props.studentInfo} votes={props.votes} setVotes={props.setVotes}/>
    </>) : (
        <div role='status' aria-live='polite'>Loading...</div>
    )
  ); 
}

export default Vote;
